import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-ktostamm-lieferant-master-view',
  imports: [],
  templateUrl: './ktostamm-lieferant.master-view.html',
  styleUrls: ['./ktostamm-lieferant.master-view.css'],
})
export class KtostammLieferantMasterView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
